export const contactUs = () => {
  window.open(
    'https://www.praetorian.com/contact-us',
    '_blank',
    'noopener noreferrer'
  );
};
